
import React, { useState, useEffect, useRef } from "react";
import "./CreateUpdateRole.scss";
import "../DashBoard/sliding.css";

import axios, { all } from "axios";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { sidebarReducer } from "../../Redux/store";
import { userReducer } from "../../Redux/store";
import { useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import SearchBarComponent from "../../components/searchBar/searchBarComponent";
import { ReactComponent as UserSVG } from "../../images/new_ui/role.svg";
import { ReactComponent as UsersSVG } from "../../images/new_ui/users.svg";
import { ReactComponent as DeleteSVG } from "../../images/new_ui/delete-purple.svg";
import { ReactComponent as EditSVG } from "../../images/new_ui/edit-purple.svg";
import { ReactComponent as AddSVG } from "../../images/new_ui/addArrow.svg";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { styled } from "@mui/system";

import Typography from "@mui/material/Typography";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Backdrop from "@mui/material/Backdrop";
import IndeterminateCheckBoxIcon from "@mui/icons-material/IndeterminateCheckBox";
import { useLocation } from "react-router-dom";

LocalHospitalIcon = styled(LocalHospitalIcon)(({ theme }) => ({
  color: "#A685FA", // Customize the icon color here
}));
IndeterminateCheckBoxIcon = styled(IndeterminateCheckBoxIcon)(({ theme }) => ({
  color: "#A685FA", // Customize the icon color here
}));

const CustomCheckbox = styled("input")({
  color: "#A685FA",
  "&:checked": {
    color: "#A685FA",
  },
  "&:not(:checked)": {
    color: "#A685FA",
  },
});

function CreateUpdateRole() {
  // Dispatch function
  const dispatch = useDispatch();

  // API related selectors
  const token = useSelector((state) => state.AccessTocken.accessTocken);

  // Permission for Roles

  // console.log("hggfdfdfgdgfh",te_role_id)
  const user_edit = useSelector((state) => state.user.user_edit);
  const [userData, setUserData] = useState([]);

  const [userValidated, setUserValidated] = useState(false);
  const apiLoad = useSelector((state) => state.sidebar.apiLoad);
  const [isOpen, setIsOpen] = useState(false);
  const [parentChecked1, setParentChecked1] = useState(false);
  const [childChecked1, setChildChecked1] = useState([false, false, false]);
  const [parentChecked2, setParentChecked2] = useState(false);
  const [childChecked2, setChildChecked2] = useState([false, false, false]);
  const [parentChecked3, setParentChecked3] = useState(false);
  const [childChecked3, setChildChecked3] = useState([false, false, false]);
  const location = useLocation();

  const handleParentCheckboxChange1 = () => {
    const newState = !parentChecked1;
    setParentChecked1(newState);
    setChildChecked1([newState, newState, newState]);
  };

  const handleChildCheckboxChange1 = (index) => {
    const newChildChecked1 = [...childChecked1];
    newChildChecked1[index] = !newChildChecked1[index];
    setChildChecked1(newChildChecked1);
    setParentChecked1(newChildChecked1.every((checked) => checked));
  };
  const handleParentCheckboxChange2 = () => {
    const newState = !parentChecked2;
    setParentChecked2(newState);
    setChildChecked2([newState, newState, newState]);
  };

  const handleChildCheckboxChange2 = (index) => {
    const newChildChecked2 = [...childChecked2];
    newChildChecked2[index] = !newChildChecked2[index];
    setChildChecked2(newChildChecked2);
    setParentChecked2(newChildChecked2.every((checked) => checked));
  };
  const handleParentCheckboxChange3 = () => {
    const newState = !parentChecked3;
    setParentChecked3(newState);
    setChildChecked3([newState, newState, newState]);
  };

  const handleChildCheckboxChange3 = (index) => {
    const newChildChecked3 = [...childChecked3];
    newChildChecked3[index] = !newChildChecked3[index];
    setChildChecked3(newChildChecked3);
    setParentChecked3(newChildChecked3.every((checked) => checked));
  };

  const [te_role_id, setTe_role_id] = useState();
  const openPopup = () => {
    setIsOpen(true);
  };

  const options = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const listLimit = useSelector((state) => state.AccessTocken.recordsPerPage);

  // division response for Division Dropdown

  async function getUsersList() {
    dispatch(sidebarReducer.apiLoad(true));
    // setApiLaod(true);
    await axios
      .get(
        "rolepermission/allUsersForSpecificCompany/" +
        JSON.parse(sessionStorage.getItem("userdata")).te_companyid
      )
      // .get("userProfile/getAllUsers")
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          //setApiLaod(false);
          // console.log("getAllUsers2", response.data.length);
          setUserData(response.data.result[0].response);
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  }
  var addnameColor = "black";

  if (userValidated) {
    addnameColor = "green";
  } else {
    addnameColor = "red";
  }
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const userParam = params.get("role");
    console.log(userParam);

    if (userParam) {
      // Call your function here based on the user parameter
      console.log("User parameter:", userParam);
      // getUserById(setTe_role_id);
      getUserById(userParam);
      setTe_role_id(userParam);
      // Example function call: myFunction(userParam);
    }
    // getRolesList();
  }, [location]);

  const colors = [
    "#CD853F",
    "#DB7093",
    "#778899",
    "#FF00FF",
    "#483D8B",
    "#FF0000",
    "#696969",
    "#DC143C",
    "#556B2F",
  ];
  const [rolesList, setRolesList] = useState(null);
  const [missingFields, setMissingFields] = useState([]);
  const [buttonclicked, setButtonclicked] = useState(false);
  const [formData, setFormData] = useState({
    roleName: "",
    roleDescription: "",
    roleType: "cms_user",
    te_moduleid: 1,
    te_view: 0,
    te_add: 0,
    te_edit: 0,
    te_delete: 0,
    te_download: 0,
    te_draw: 0,
    te_comments: 0,
    te_chats: 0,
    te_transcripts: 0,
    te_assetlibrary: 0,
    te_avatars: 0,
    te_sessionrecording: 0,
    te_catchups: 0
  });
  const resetFormData = () => {
    setFormData({
      roleName: "",
      roleDescription: "",
      roleType: "cms_user",
      te_moduleid: 2,
      te_view: 0,
      te_add: 0,
      te_edit: 0,
      te_delete: 0,
      te_download: 0,
      te_draw: 0,
      te_comments: 0,
      te_chats: 0,
      te_transcripts: 0,
      te_assetlibrary: 0,
      te_avatars: 0,
      te_sessionrecording: 0,
      te_catchups: 0
    });
  };


  async function getRolesList() {
    dispatch(sidebarReducer.apiLoad(true));
    try {
      const response = await axios.get(
        "rolepermission/usersRolePermissionBycompanyId/" +
        JSON.parse(sessionStorage.getItem("userdata")).te_companyid
      );
      if (response.status === 200) {
        dispatch(sidebarReducer.apiLoad(false));
        setRolesList(response.data.result[0].response);
      } else if (response.status !== 200) {
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      }
    } catch (err) {
      dispatch(sidebarReducer.stringUpdate("AppDown"));
    }
  }
  const [expanded, setExpanded] = useState(null);


  const handleExpandClick = (panel) => (event) => {
    event.stopPropagation();  
    setExpanded(expanded === panel ? null : panel);
  };

  const handleChange = (panel) => (event, isExpanded) => {
    event.stopPropagation();  
  };
  const getExpandIcon = (panel) => {
    return (
      <div onClick={handleExpandClick(panel)}>
        {expanded === panel ? <IndeterminateCheckBoxIcon /> : <LocalHospitalIcon />}
      </div>
    );
  };


  const handleSubmit = (e) => {
    e.preventDefault();

   
    window.location.pathname === "/role-update"
      ? UpdateUser()
      : createRole();
  };

  const createRole = async () => {
    try {
      const response = await axios.post("roles/add", formData, {
        headers: {
          Authorization:
            "Bearer" + " " + sessionStorage.getItem("access_token"),
        },
      });
      console.log("response", response);

      dispatch(sidebarReducer.apiLoad(false));
      if (response.data.status === 200) {
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        resetFormData();
        setButtonclicked(false);
      } else {
        console.log("abbb",response)
        toast.warn(response.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    } catch (error) {
      
      toast.warn(error.response.data.data, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      toast.error(error.response.data.message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
     
    }
  };
  const UpdateUser = async () => {
    try {
      const response = await axios.put(`/roles/update/${te_role_id}`, formData, {
        headers: {
          Authorization:
            "Bearer" + " " + sessionStorage.getItem("access_token"),
        },
      });
      console.log("response", response);

      dispatch(sidebarReducer.apiLoad(false));
      if (response.data.status === 200) {
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        resetFormData();
      } else {
        console.log("abbb",response)
        toast.warn(response.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    } catch (error) {
      console.log("abbb",error)
      toast.error(error.response.data.message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      console.error("Error fetching role details:", error);
    }
  };


  const validateName = (name) => {
    const nameRegex = /^[A-Za-z]+(?:\s[A-Za-z]+)*$/;
    console.log("emailRegex.test(email)", nameRegex.test(name));
    return nameRegex.test(name);
  };

  const handleRoleDetailsChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (type === 'checkbox') {
      setFormData(prevState => ({
        ...prevState,
        [name]: checked ? 1 : 0
      }));
    } else {
      setFormData(prevState => ({
        ...prevState,
        [name]: value
      }));
  
      if (name === "roleName") {
        if (value) {
          if (!validateName(value)) {
            console.error("Please enter a valid name.");
            setMissingFields(prevFields => {
              if (!prevFields.includes("roleName")) {
                return [...prevFields, "roleName"];
              }
              return prevFields;
            });
          } else {
            setMissingFields(prevFields => 
              prevFields.filter(item => item !== "roleName")
            );
          }
        }
      }
    }
  };


  console.log("te_role", te_role_id);
  const roleOptions = ["Admin", "Manager", "Employee"];
  const heading =
    window.location.pathname === "/role-update"
      ? "Edit Role"
      : "Create New Role";
  console.log(" window.location.pathname", window.location.pathname);
  const submitbutton =
    window.location.pathname === "/role-update" ? "Save Changes" : "Save Role";
  const customStyles = {
    option: (provided, state) => ({
      ...provided,

      color: state.isSelected ? "white" : "white",
      backgroundColor: state.isSelected ? "#666666" : "#1A1A1A",
    }),
  };

  const getUserById = async (userParam) => {
    console.log(userParam);
    if (userParam) {
      const response = await axios.get("roles/details/" + userParam, {
        headers: {
          Authorization:
            "Bearer" + " " + sessionStorage.getItem("access_token"),
        },
      });
      if (response.status === 200) {
        setFormData({
          roleName: response.data.data.te_role_name,
          roleDescription: response.data.data.te_role_description,
        });
        // setSelectedOption(response.data.data[0].te_role_id)
      }
    } else {
      // instance.logoutRedirect({ postLogoutRedirectUri: "/" });
    }
  };


  const handButtonclick = () => {
    setButtonclicked(true);
  };

  return (
    <div className="update-roles-new">
      <ToastContainer closeButton={false} />
      <div className="container-fluid">
        <div className="search-section">
          <div></div>
          <SearchBarComponent className="search-bar-div" />

        </div>

        <div className="container">
      
          <div className="main-title">{heading}</div>
          <div className="roles-and-permissions">
            <div className="main-container">
              <form onSubmit={handleSubmit}>
                <div className="role-items role-row">
                  <div className="role-details column">
                    <div className="aling-label-input">
                      <label>
                        <span style={{ color: "#C91616" }}>*</span> Role Name{" "}
                      </label>
                      <input
                        type="text"
                        name="roleName"
                        value={formData.roleName}
                        onChange={handleRoleDetailsChange}
                        placeholder={"Enter Role Name"}
                      ></input>
                      {formData.roleName === "" && buttonclicked ? (
                        <p style={{ color: "red" }}>Please enter a name.</p>
                      ) : (
                        <p
                          style={{
                            display: missingFields.includes("roleName")
                              ? "block"
                              : "none",
                            color: "#C91616",
                          }}
                        >
                          Please enter a valid name.
                        </p>
                      )}
                    </div>
                    <div className="aling-label-input">
                      <label>Role Description</label>
                      <div>
                        <textarea
                          rows="7"
                          name="roleDescription"
                          value={formData.roleDescription}
                          onChange={handleRoleDetailsChange}
                          placeholder="Enter your Description here.."
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div className="list-permission-container column">
                    <div className="title">
                      <div>Permissions</div>
                    </div>
                    {/* <div className="list-permissions-wrapper">
                      <div className="View-Content">
                       
                        <Accordion expanded={expanded === "View Content"} onChange={handleChange("View Content")}>
                          <AccordionSummary expandIcon={getExpandIcon("View Content")} aria-controls="View Content1" id="View Content1">
                            <div className="checkbox-clicked">
                              <input type="checkbox" checked={parentChecked1} onChange={handleParentCheckboxChange1} />
                              <Typography>User</Typography>
                            </div>
                          </AccordionSummary>
                          <AccordionDetails>
                            <div className="checkbox-clicked">
                              <input type="checkbox" checked={childChecked1[0]} onChange={() => handleChildCheckboxChange1(0)} />
                              <Typography>add</Typography>
                            </div>
                            <div className="checkbox-clicked">
                              <input type="checkbox" checked={childChecked1[1]} onChange={() => handleChildCheckboxChange1(1)} />
                              <Typography>edit</Typography>
                            </div>
                            <div className="checkbox-clicked">
                              <input type="checkbox" checked={childChecked1[2]} onChange={() => handleChildCheckboxChange1(2)} />
                              <Typography>delete</Typography>
                            </div>
                             <div className="checkbox-clicked">
                              <input type="checkbox" checked={childChecked1[2]} onChange={() => handleChildCheckboxChange1(2)} />
                              <Typography>view</Typography>
                            </div>
                          </AccordionDetails>
                        </Accordion>
                      </div>

                      <div className="add-Content">
                       
                        <Accordion expanded={expanded === "Add Content"} onChange={handleChange("Add Content")}>
                          <AccordionSummary expandIcon={getExpandIcon("Add Content")} aria-controls="Add Content1" id="Add Content1">
                            <div className="checkbox-clicked">
                              <input type="checkbox" checked={parentChecked2} onChange={handleParentCheckboxChange2} />
                              <Typography>Content</Typography>
                            </div>
                          </AccordionSummary>
                          <AccordionDetails>
                            <div className="checkbox-clicked">
                              <input type="checkbox" checked={childChecked2[0]} onChange={() => handleChildCheckboxChange2(0)} />
                              <Typography>Add</Typography>
                            </div>
                            <div className="checkbox-clicked">
                              <input type="checkbox" checked={childChecked2[1]} onChange={() => handleChildCheckboxChange2(1)} />
                              <Typography>Edit</Typography>
                            </div>
                            <div className="checkbox-clicked">
                              <input type="checkbox" checked={childChecked2[2]} onChange={() => handleChildCheckboxChange2(2)} />
                              <Typography>Delete</Typography>
                            </div>
                             <div className="checkbox-clicked">
                              <input type="checkbox" checked={childChecked2[2]} onChange={() => handleChildCheckboxChange2(2)} />
                              <Typography>View</Typography>
                            </div>
                          </AccordionDetails>
                        </Accordion>
                      </div>

                      <div className="Delete-Content">
                        
                        <Accordion expanded={expanded === "Delete Content"} onChange={handleChange("Delete Content")}>
                          <AccordionSummary expandIcon={getExpandIcon("Delete Content")} aria-controls="Delete Content1" id="Delete Content1">
                            <div className="checkbox-clicked">
                              <input type="checkbox" checked={parentChecked3} onChange={handleParentCheckboxChange3} />
                              <Typography>Role</Typography>
                            </div>
                          </AccordionSummary>
                          <AccordionDetails>
                            <div className="checkbox-clicked">
                              <input type="checkbox" checked={childChecked3[0]} onChange={() => handleChildCheckboxChange3(0)} />
                              <Typography>Add</Typography>
                            </div>
                            <div className="checkbox-clicked">
                              <input type="checkbox" checked={childChecked3[1]} onChange={() => handleChildCheckboxChange3(1)} />
                              <Typography>Edit</Typography>
                            </div>
                            <div className="checkbox-clicked">
                              <input type="checkbox" checked={childChecked3[2]} onChange={() => handleChildCheckboxChange3(2)} />
                              <Typography>Delete</Typography>
                            </div>
                             <div className="checkbox-clicked">
                              <input type="checkbox" checked={childChecked3[2]} onChange={() => handleChildCheckboxChange3(2)} />
                              <Typography>View</Typography>
                            </div>
                          </AccordionDetails>
                        </Accordion>
                        <Accordion expanded={expanded === "Delete Content"} onChange={handleChange("Delete Content")}>
                          <AccordionSummary expandIcon={getExpandIcon("Delete Content")} aria-controls="Delete Content1" id="Delete Content1">
                            <div className="checkbox-clicked">
                              <input type="checkbox" checked={parentChecked3} onChange={handleParentCheckboxChange3} />
                              <Typography>Device</Typography>
                            </div>
                          </AccordionSummary>
                          <AccordionDetails>
                            <div className="checkbox-clicked">
                              <input type="checkbox" checked={childChecked3[0]} onChange={() => handleChildCheckboxChange3(0)} />
                              <Typography>Add</Typography>
                            </div>
                            <div className="checkbox-clicked">
                              <input type="checkbox" checked={childChecked3[1]} onChange={() => handleChildCheckboxChange3(1)} />
                              <Typography>Edit</Typography>
                            </div>
                            <div className="checkbox-clicked">
                              <input type="checkbox" checked={childChecked3[2]} onChange={() => handleChildCheckboxChange3(2)} />
                              <Typography>Delete</Typography>
                            </div>
                             <div className="checkbox-clicked">
                              <input type="checkbox" checked={childChecked3[2]} onChange={() => handleChildCheckboxChange3(2)} />
                              <Typography>View</Typography>
                            </div>
                          </AccordionDetails>
                        </Accordion>
                      </div>
                    </div> */}
                     <div className="list-permissions-wrapper">
                     <div className="permission-item">
    <input 
      type="checkbox" 
      id="te_view" 
      name="te_view" 
      checked={formData.te_view === 1}
      onChange={handleRoleDetailsChange}
    />
    <label htmlFor="te_view">View</label>
  </div>
  <div className="permission-item">
    <input 
      type="checkbox" 
      id="te_add" 
      name="te_add" 
      checked={formData.te_add === 1}
      onChange={handleRoleDetailsChange}
    />
    <label htmlFor="te_add">Add</label>
  </div>
  <div className="permission-item">
    <input 
      type="checkbox" 
      id="te_edit" 
      name="te_edit" 
      checked={formData.te_edit === 1}
      onChange={handleRoleDetailsChange}
    />
    <label htmlFor="te_edit">Edit</label>
  </div>
  <div className="permission-item">
    <input 
      type="checkbox" 
      id="te_delete" 
      name="te_delete" 
      checked={formData.te_delete === 1}
      onChange={handleRoleDetailsChange}
    />
    <label htmlFor="te_delete">Delete</label>
  </div>
  <div className="permission-item">
    <input 
      type="checkbox" 
      id="te_draw" 
      name="te_draw" 
      checked={formData.te_draw === 1}
      onChange={handleRoleDetailsChange}
    />
    <label htmlFor="te_draw">Draw</label>
  </div>
  <div className="permission-item">
    <input 
      type="checkbox" 
      id="te_comments" 
      name="te_comments" 
      checked={formData.te_comments === 1}
      onChange={handleRoleDetailsChange}
    />
    <label htmlFor="te_comments">Comments</label>
  </div>
 
  <div className="permission-item">
    <input 
      type="checkbox" 
      id="te_chats" 
      name="te_chats" 
      checked={formData.te_chats=== 1}
      onChange={handleRoleDetailsChange}
    />
    <label htmlFor="te_chats">Chats</label>
  </div>
  <div className="permission-item">
    <input 
      type="checkbox" 
      id="te_transcripts" 
      name="te_transcripts" 
      checked={formData.te_transcripts=== 1}
      onChange={handleRoleDetailsChange}
    />
    <label htmlFor="te_transcripts">Transcripts</label>
  </div>
  <div className="permission-item">
    <input 
      type="checkbox" 
      id="te_assetlibrary" 
      name="te_assetlibrary" 
      checked={formData.te_assetlibrary=== 1}
      onChange={handleRoleDetailsChange}
    />
    <label htmlFor="te_assetlibrary">Asset Library</label>
  </div>

  <div className="permission-item">
    <input 
      type="checkbox" 
      id="te_avatars" 
      name="te_avatars" 
      checked={formData.te_avatars=== 1}
      onChange={handleRoleDetailsChange}
    />
    <label htmlFor="te_avatars">Avatars</label>
  </div>
  <div className="permission-item">
    <input 
      type="checkbox" 
      id="te_sessionrecording" 
      name="te_sessionrecording" 
      checked={formData.te_sessionrecording=== 1}
      onChange={handleRoleDetailsChange}
    />
    <label htmlFor="te_sessionrecording">Session Recording</label>
  </div>
   
    <div className="permission-item">
    <input 
      type="checkbox" 
      id="te_catchups" 
      name="te_catchups" 
      checked={formData.te_catchups === 1}
      onChange={handleRoleDetailsChange}
    />
    <label htmlFor="te_catchups">Catchups</label>
  </div>
  </div>
                  </div>
                </div>

                <div className="buttons-container role-row">
                  <div className="full-column">
                    <button type="submit" onClick={handButtonclick}> {submitbutton}</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* add role  end */}
      </div>
    </div>
  );
}

export default CreateUpdateRole;
